<template>
    <div class="app">
        <!-- 切换语言 -->
        <div class="language" @click="setLanguage">
            {{$i18n.locale=="zh-CN"?"ENGLISH":"中文"}}
        </div>

        <!-- 搜索栏 -->
        <div class="search-bar">
            <input
                    type="text"
                    :placeholder="$t('l.document_search')"
                    v-model="searchKeyword"
                    class="search-input"
            />
            <span class="search-icon" @click="handleSearch">🔍</span>
        </div>

        <!-- 文档列表 -->
        <div class="document-list">
            <!-- 加载状态 -->
            <div v-if="loading" class="loading">
                {{$t('l.hint46')}}
            </div>

            <!-- 无数据状态 -->
            <div v-else-if="this.documents.length === 0" class="no-data">
                {{$t('l.no_datas')}}
            </div>

            <!-- 文档列表 -->
            <div v-else>
                <div
                        v-for="(doc, index) in documents"
                        :key="index"
                        class="document-item"
                >
                    <div class="document-info">
                        <div class="document-title">{{$i18n.locale=="zh-CN"?doc.productname:doc.productnameen}}</div>
                        <div class="document-meta">
                            <span class="document-size">{{$t('l.access_count')}}：{{doc.number}}</span>
                            <span class="document-count">{{$t('l.document_number')}}：{{getDocumentCount(index)}}</span>
                            <span class="document-btn"
                                  @click="viewDocuments(doc.productcode)">{{$t('l.view_document')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分页控件 -->
        <div class="pagination">
            <button
                    class="pagination-btn"
                    :disabled="currentPage === 1"
                    @click="prevPage"
            >
                {{$t('l.previous_page')}}
            </button>
            <span class="pagination-info">
        {{ currentPage }} / {{ totalPages }}
      </span>
            <button
                    class="pagination-btn"
                    :disabled="currentPage === totalPages"
                    @click="nextPage"
            >
                {{$t('l.next_page')}}
            </button>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js';

    export default {
        name: "page-qr",
        data() {
            return {
                language: 'zh-CN',
                searchKeyword: '',
                loading: false,
                documents: [],
                currentPage: 1,
                totalPages: 1,
                pageSize: 10,
            }
        },
        methods: {
            fetchDocuments() {
                this.loading = true;
                util.ajax.post('/wx/qr/getProductList', {
                    params: {
                        searchKeyword: this.searchKeyword,
                        currentPage: this.currentPage,
                        pageSize: this.pageSize
                    }
                }).then((res) => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.totalPages = res.data.last_page;
                        this.documents = res.data.data;
                    }
                }).catch(e => {
                    this.loading = false;
                });
            },
            viewDocuments(productCode) {
                window.location.href = "http://qr.sylg.cn/qr/" + productCode;
            },
            getDocumentCount(index) {
                var documents = this.documents[index];
                var instructions = documents.instructions ? JSON.parse(documents.instructions) : [];
                var count = 0;
                for (var i = 0; i < instructions.length; i++) {
                    if (this.$i18n.locale == "zh-CN" && instructions[i].type == 0) {
                        count++;
                    }
                    if (this.$i18n.locale == "en-US" && instructions[i].type == 1) {
                        count++;
                    }
                }
                return count;
            },
            handleSearch() {
                this.currentPage = 1;
                this.fetchDocuments();
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.fetchDocuments();
                }
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    this.fetchDocuments();
                }
            },
            getPreferredLanguage() {
                var systemLang = navigator.language || navigator.userLanguage || 'zh';
                return systemLang.startsWith('zh') ? 'zh-CN' : 'en-US';
            },
            setLanguage() {
                this.$i18n.locale = this.$i18n.locale == "zh-CN" ? "en-US" : "zh-CN";
            }
        },
        mounted: function () {
            this.$i18n.locale = this.getPreferredLanguage();
            this.fetchDocuments();
        },
    }
</script>


<style scoped>
    .app {
        height: 100%;
        width: 100%;
        padding: 15px;
        background-image: url("../../../public/images/wx/qr_top.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #f5f5f5;
        box-sizing: border-box;
    }

    /* 切换语言 */
    .language {
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        color: white;
        width: 100%;
        text-align: end;
        margin-top: -5px;
        margin-bottom: 5px;
    }

    /* 搜索栏 */
    .search-bar {
        position: relative;
        margin-bottom: 15px;
    }

    .search-input {
        width: 100%;
        padding: 10px 20px 10px 10px;
        border: 1px solid #ddd;
        border-radius: 20px;
        font-size: 14px;
        outline: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .search-icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        color: #999;
    }

    /* 文档列表 */
    .document-list {
        background-color: #fff;
        border-radius: 8px;
        padding: 0 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        margin-bottom: 15px;
        height: calc(100% - 145px);
    }

    /* 加载状态 */
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        font-size: 14px;
        color: #666;
    }

    .loading::after {
        content: '';
        width: 20px;
        height: 20px;
        margin-left: 10px;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #4CAF50;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* 无数据状态 */
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        font-size: 14px;
        color: #999;
    }

    .document-item {
        display: flex;
        gap: 12px;
        padding: 10px;
        border-bottom: 1px solid #f0f0f0;
        transition: all 0.3s ease;
    }

    .document-item:hover {
        background-color: #f9f9f9;
    }

    .document-item:last-child {
        border-bottom: none;
    }

    .document-info {
        flex: 1;
        min-width: 0;
    }

    .document-title {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 8px;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .document-meta {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #999;
    }

    .document-size {
        margin-right: 12px;
    }

    .document-btn {
        color: #2a9fff;
    }

    /* 分页控件 */
    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .pagination-btn {
        padding: 3px 15px;
        border: 1px solid #ddd;
        border-radius: 4px;
        background-color: #fff;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .pagination-btn:hover:not(:disabled) {
        background-color: #f0f0f0;
    }

    .pagination-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .pagination-info {
        font-size: 14px;
        color: #666;
        margin: 0 15px;
    }
</style>